import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { ContentCopy } from '@mui/icons-material';


type CopyProps = {
    value: string,
    space?: boolean,
}

const Copy = ({ value, space }: CopyProps) => {
    const {t} = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    return (
        <ContentCopy
            sx={{
                color: 'text.disabled',
                cursor: 'pointer',
                '&:hover': {
                    color: 'text.primary',
                },
                ...space ? {mr: 1}: {}
            }}
            fontSize="small"
            onClick={e => {
                e.stopPropagation();
                navigator.clipboard.writeText(value)
                    .then(() => enqueueSnackbar(t('copied', {value}), {
                        autoHideDuration: 1000,
                    }));
            }}
        />
    );
};

export default Copy;
